import {Form, Input, message, Modal, ModalProps} from 'antd';
import React from 'react';
import Style from './index.module.scss';
import useRequestFn from '../../../../../../Utils/Hooks/useRequestFn';
import {errorMessage} from '../../../../../../Utils/common';
import {changePwd} from '../../../service';

interface Props extends ModalProps {
    id: string;
    onOk: () => void;
}

interface FormProp {
    pwd: string;
    pwd2: string;
}

const Index = ({id, onOk, ...props}: Props) => {
    const [form] = Form.useForm<FormProp>();
    const [save, {loading: saveLoading}] = useRequestFn(changePwd);
    async function onFinish(formData: FormProp) {
        if (formData.pwd !== formData.pwd2) {
            return message.error('两次输入密码不一致');
        }
        try {
            await save(id, formData.pwd);
            message.success('修改成功!');
            onOk();
        } catch (e) {
            message.error(errorMessage(e));
        }
    }

    return (
        <Modal
            {...props}
            title="修改密码"
            confirmLoading={saveLoading}
            onOk={form.submit}>
            <div className={Style.root}>
                <Form form={form} onFinish={onFinish} labelCol={{span: 6}}>
                    <Form.Item
                        name="pwd"
                        label="密码"
                        rules={[{required: true}]}>
                        <Input.Password />
                    </Form.Item>
                    <Form.Item
                        name="pwd2"
                        label="再次输入密码"
                        rules={[{required: true}]}>
                        <Input.Password />
                    </Form.Item>
                </Form>
            </div>
        </Modal>
    );
};

export default Index;
